import { Center } from '../../lib/types/models/center/center'
import { AssignJourneyToCenterRequestInput } from '../../lib/types/models/center/center-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const updateAssignedJourneys = (input: UpdateInput<AssignJourneyToCenterRequestInput>) => {
  const { id, ...rest } = input
  return restApiClient
    .url(constructApiUrl(API.centers.updateAssignedJourneys.url, { id }))
    .patch<Center, Partial<AssignJourneyToCenterRequestInput>>(rest)
}
